import { Button, Radio, RadioGroup, Spinner } from "@blueprintjs/core";
import React, { useContext, useState } from "react";
import { v4 } from "uuid";
import Inputbox from "../../components/elements/Inputbox.Element";
import { firebaseContext } from "../../contexts/FirebaseContext";
import { Player } from "../../interfaces/Player.Interface";

export default function AddNewPlayerComponent() {
  const firebase = useContext(firebaseContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const initNewPlayer: Player = {
    playerId: v4(),
    firstName: "",
    lastName: "",
    position: "foward",
    jerseyNumber: 0,
    imageUrl: null,
    role: 1,
  };

  const [newPlayer, setNewPlayer] = useState<Player>({ ...initNewPlayer });

  const onChange = (key: string, value: string) => {
    setError("");
    setNewPlayer((prev) => {
      return {
        ...prev,
        [key]: value,
      };
    });
  };

  const onChangeJerseyNumber = (key: string, value: string) => {
    setNewPlayer((prev) => {
      return {
        ...prev,
        [key]: parseInt(value),
      };
    });
  };

  const { firstName, lastName, position, jerseyNumber } = newPlayer;

  const onClickSubmit = async () => {
    if (firstName && lastName && jerseyNumber && jerseyNumber > 0 && position) {
      const call = firebase.functions().httpsCallable("addPlayer");

      const res = await call({ ...newPlayer });
      if (res.data.error) {
        setError("Save incomplete, please try again later");
      } else {
        setNewPlayer(initNewPlayer);
      }
      setLoading(false);
    } else {
      setError("Invalid arguments detected");
    }
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          textAlign: "center",
          padding: 25,
        }}
      >
        Add new player
      </div>
      <div className="col-md-8 col-xs-10 col-md-offset-2 col-xs-offset-1">
        <Inputbox
          value={firstName}
          label="First Name"
          placeHolder="Enter your first name"
          labelInfo="(eg. Lasantha)"
          id="firstName"
          disabled={loading}
          onChange={(val) => onChange("firstName", val)}
        />
        <Inputbox
          value={lastName}
          key="lastName"
          label="Last Name"
          placeHolder="Enter your last name"
          labelInfo="(eg. Senanayake)"
          id="lastName"
          disabled={loading}
          onChange={(val) => onChange("lastName", val)}
        />
        <Inputbox
          value={jerseyNumber!.toString()}
          key="jerseyNumber"
          label="Jersey Number"
          placeHolder="Enter your jersey number"
          labelInfo="(eg. 7)"
          id="jerseyNumber"
          onChange={(val) => onChangeJerseyNumber("jerseyNumber", val)}
          disabled={loading}
          type="number"
        />
        <RadioGroup
          selectedValue={position}
          label="Select position"
          disabled={loading}
          onChange={(e) => {
            onChange("position", (e.target as any).defaultValue);
          }}
        >
          <Radio label="Foward" value="foward" />
          <Radio label="Midfilder" value="midfield" />
          <Radio label="Defender" value="defend" />
          <Radio label="Goalkeeper" value="goalkeeping" />
        </RadioGroup>
        <div
          style={{ height: 40, fontSize: 15, color: "#e8232d", paddingTop: 20 }}
        >
          {error}
        </div>
        <div style={{ paddingTop: 20, paddingBottom: 50 }}>
          {loading ? (
            <Spinner />
          ) : (
            <Button
              disabled={loading}
              onClick={onClickSubmit}
              intent="success"
              text="Add New Player"
            />
          )}
        </div>
      </div>
    </div>
  );
}
